<template>
    <div id="contenedor-main-listado">
        <template
            v-if="!$vuetify.breakpoint.mobile">
            <desktop :contratosEstatus="contratosEstatus"></desktop>
        </template>
        <template
            v-else>
            <mobile></mobile>
        </template>
    </div>
</template>

<script>
import Desktop from './Desktop.vue';
import Mobile from './Mobile.vue';

export default {
  name: 'MainListado',
  props: {
    contratosEstatus: {
      type: Array,
      required: true,
    },
  },
  components: {
    Desktop,
    Mobile,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
